/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinOrganizationLookup
 */
export interface JoinOrganizationLookup {
    /**
     * User's email.
     * @type {string}
     * @memberof JoinOrganizationLookup
     */
    email: string;
}

/**
 * Check if a given object implements the JoinOrganizationLookup interface.
 */
export function instanceOfJoinOrganizationLookup(value: object): boolean {
    if (!('email' in value)) return false;
    return true;
}

export function JoinOrganizationLookupFromJSON(json: any): JoinOrganizationLookup {
    return JoinOrganizationLookupFromJSONTyped(json, false);
}

export function JoinOrganizationLookupFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinOrganizationLookup {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function JoinOrganizationLookupToJSON(value?: JoinOrganizationLookup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

